import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import { A } from 'components/common/Link/Link'
import Theme from 'components/common/Theme/Theme'

const BreadcrumbTwoColumns = ({
  placeholders: {
    links = [],
    right = []
  } = {}
}) =>
  <Wrapper data-printless>
    <Breadcrumb data-at-breadcrumbk-link>{ links }</Breadcrumb>
    <PageOptions data-at-pageoptions>{ right }</PageOptions>
  </Wrapper>

BreadcrumbTwoColumns.propTypes = {
  placeholders: PropTypes.shape({
    links: PropTypes.arrayOf(),
    right: PropTypes.arrayOf()
  })
}

export default BreadcrumbTwoColumns

const Wrapper = styled.div`
  ${Mixin.responsive('margin', '40px 0 35px', '15px 15px 10px')};
  ${Mixin.clearFix()};
`

const Breadcrumb = styled.div`
  float: left;
`

const PageOptions = styled.div`
  float: right;

  & ${A} + ${A} {
    ${Media.desktop`
      padding-left: 12px;
      margin-left: 12px;
      border-left: 1px solid ${Theme.colors.light_grey};
    `}
  }
`
